import { useState } from "react";
import FadeIn from "@/components/FadeIn";

const PROJECT_TYPES = [
  "Construcție la Roșu",
  "Construcție la Cheie",
  "Ansamblu Rezidențial",
  "Renovare & Extindere",
  "Altele",
];

const INITIAL = {
  nume: "",
  email: "",
  telefon: "",
  tipProiect: "",
  localitate: "",
  mesaj: "",
};

const LABELS = {
  nume: "Nume și Prenume",
  email: "Adresă de Email",
  telefon: "Număr de Telefon",
  tipProiect: "Tipul Proiectului",
  localitate: "Localitatea",
  mesaj: "Mesaj",
};

export default function Contact() {
  const [form, setForm] = useState(INITIAL);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (errors[name]) {
      setErrors((er) => ({ ...er, [name]: "" }));
    }
  };

  const validate = () => {
    const er = {};
    Object.keys(form).forEach((k) => {
      if (!form[k].trim()) {
        er[k] = `Câmpul "${LABELS[k]}" este obligatoriu.`;
      }
    });
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      er.email = "Adresa de email nu este validă.";
    }
    return er;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const er = validate();
    if (Object.keys(er).length > 0) {
      setErrors(er);
      return;
    }
    setErrors({});
    setSubmitted(true);
  };

  const resetForm = () => {
    setForm(INITIAL);
    setErrors({});
    setSubmitted(false);
  };

  return (
    <div data-testid="contact-page">
      <header className="sb-page-header">
        <div className="sb-container">
          <h1>Contact</h1>
          <p>Solicită o ofertă gratuită sau programează o consultație</p>
        </div>
      </header>

      <section className="sb-section">
        <div className="sb-container">
          <div className="sb-contact-grid">
            {/* Left: info */}
            <FadeIn className="sb-contact-info" data-testid="contact-info">
              <h2>Date de Contact</h2>
              <ul className="sb-contact-list">
                <li>
                  <span className="icon" aria-hidden="true">📍</span>
                  <div>
                    <span className="label">Adresă</span>
                    Strada Păcurari 112, Iași 700521
                  </div>
                </li>
                <li>
                  <span className="icon" aria-hidden="true">📞</span>
                  <div>
                    <span className="label">Telefon</span>
                    <a href="tel:+40232456789">+40 232 456 789</a>
                  </div>
                </li>
                <li>
                  <span className="icon" aria-hidden="true">📧</span>
                  <div>
                    <span className="label">Email</span>
                    <a href="mailto:office@structbuild.ro">office@structbuild.ro</a>
                  </div>
                </li>
                <li>
                  <span className="icon" aria-hidden="true">⏰</span>
                  <div>
                    <span className="label">Program</span>
                    Luni–Vineri 08:00–17:00
                  </div>
                </li>
              </ul>

              <div className="sb-map-wrapper" data-testid="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2713.276!2d27.5703!3d47.1585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40cafb6f0c183c0d%3A0x7f4a1b2b3c4d5e6f!2sStrada%20P%C4%83curari%2C%20Ia%C8%99i!5e0!3m2!1sro!2sro!4v1700000000000"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Locație StructBuild Construct pe hartă"
                />
              </div>
            </FadeIn>

            {/* Right: form */}
            <FadeIn delay={140}>
              <div className="sb-contact-form" data-testid="contact-form-card">
                {!submitted ? (
                  <>
                    <h2>Trimite-ne un Mesaj</h2>
                    <form onSubmit={handleSubmit} noValidate data-testid="contact-form">
                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="nume">{LABELS.nume}</label>
                        <input
                          id="nume"
                          name="nume"
                          type="text"
                          className="sb-input"
                          value={form.nume}
                          onChange={handleChange}
                          data-testid="form-input-nume"
                          aria-invalid={!!errors.nume}
                        />
                        {errors.nume && <span className="sb-error" data-testid="error-nume">{errors.nume}</span>}
                      </div>

                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="email">{LABELS.email}</label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          className="sb-input"
                          value={form.email}
                          onChange={handleChange}
                          data-testid="form-input-email"
                          aria-invalid={!!errors.email}
                        />
                        {errors.email && <span className="sb-error" data-testid="error-email">{errors.email}</span>}
                      </div>

                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="telefon">{LABELS.telefon}</label>
                        <input
                          id="telefon"
                          name="telefon"
                          type="tel"
                          className="sb-input"
                          value={form.telefon}
                          onChange={handleChange}
                          data-testid="form-input-telefon"
                          aria-invalid={!!errors.telefon}
                        />
                        {errors.telefon && <span className="sb-error" data-testid="error-telefon">{errors.telefon}</span>}
                      </div>

                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="tipProiect">{LABELS.tipProiect}</label>
                        <select
                          id="tipProiect"
                          name="tipProiect"
                          className="sb-input"
                          value={form.tipProiect}
                          onChange={handleChange}
                          data-testid="form-input-tipProiect"
                          aria-invalid={!!errors.tipProiect}
                        >
                          <option value="">— Alege —</option>
                          {PROJECT_TYPES.map((t) => (
                            <option key={t} value={t}>{t}</option>
                          ))}
                        </select>
                        {errors.tipProiect && <span className="sb-error" data-testid="error-tipProiect">{errors.tipProiect}</span>}
                      </div>

                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="localitate">{LABELS.localitate}</label>
                        <input
                          id="localitate"
                          name="localitate"
                          type="text"
                          className="sb-input"
                          placeholder="ex: Iași, Pașcani, Roman..."
                          value={form.localitate}
                          onChange={handleChange}
                          data-testid="form-input-localitate"
                          aria-invalid={!!errors.localitate}
                        />
                        {errors.localitate && <span className="sb-error" data-testid="error-localitate">{errors.localitate}</span>}
                      </div>

                      <div className="sb-form-field">
                        <label className="sb-label" htmlFor="mesaj">{LABELS.mesaj}</label>
                        <textarea
                          id="mesaj"
                          name="mesaj"
                          rows={4}
                          className="sb-input"
                          style={{ resize: "vertical" }}
                          placeholder="Descrieți pe scurt proiectul dvs. — suprafață estimată, număr de camere, buget orientativ..."
                          value={form.mesaj}
                          onChange={handleChange}
                          data-testid="form-input-mesaj"
                          aria-invalid={!!errors.mesaj}
                        />
                        {errors.mesaj && <span className="sb-error" data-testid="error-mesaj">{errors.mesaj}</span>}
                      </div>

                      <button
                        type="submit"
                        className="sb-btn sb-btn-navy"
                        style={{ width: "100%", marginTop: "0.5rem" }}
                        data-testid="form-submit-btn"
                      >
                        Trimite Mesajul <span aria-hidden="true">→</span>
                      </button>
                    </form>
                  </>
                ) : (
                  <div className="sb-success" data-testid="form-success">
                    <div className="sb-success-icon" aria-hidden="true">✔</div>
                    <h3>Mesaj Trimis!</h3>
                    <p>
                      Vă mulțumim! Un reprezentant StructBuild vă va contacta în maxim 24 de ore
                      în zilele lucrătoare.
                    </p>
                    <button
                      type="button"
                      className="sb-btn sb-btn-navy-outline"
                      onClick={resetForm}
                      data-testid="form-reset-btn"
                    >
                      Trimite alt mesaj
                    </button>
                  </div>
                )}
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </div>
  );
}
